/**
 * 消息推送任务类型：与接口 task_type 一致，键为数字字符串
 * 由 i18n/index 合并进 noticeManage.taskType
 */
export type MessagePushTaskTypeLocale = 'zh-CN' | 'zh-TW' | 'en-US' | 'ja-JP'

export const messagePushTaskTypeMessages: Record<MessagePushTaskTypeLocale, Record<string, string>> = {
  'zh-CN': {
    '1': '消息推送',
    '2': '补全信息',
    '3': '删除终端',
    '5': '关机',
    '6': '重启',
    '7': '一键升级',
    '8': '全面体检',
    '9': '闪电查杀',
    '10': '全盘查杀',
    '11': '提醒卸载软件',
    '12': '开启卸载软件',
    '13': '软件分发',
    '14': '文件分发',
    '15': '优化启动项',
    '16': '恢复启动项',
    '19': '流量监控',
    '20': '弹窗拦截引擎控制',
    '21': '弹窗拦截信任列表控制',
    '22': '退出团队',
    '23': '域名拦截黑白名单',
    '24': '启动项扫描',
    '25': '控制台信息同步',
    '26': '漏洞修复',
    '27': '漏洞扫描',
    '28': '端口扫描',
    '29': '端口阻断',
    '30': '基线扫描',
    '31': '基线修复',
    '32': '团队信息变更',
    '33': '开启远程协助',
    '34': '关闭远程协助',
    '35': '开启远程登录',
    '36': '关闭远程登录',
    '37': '启用/禁用用户',
    '38': '会员权益更新',
    '39': '敏感文件扫描',
    '40': '风险项处理',
    '41': '恢复文件',
    '42': '添加信任区',
    '43': '移除信任区',
    '44': '更新信任区',
    '45': '更新隔离区',
    '46': '修改调试模式',
    '47': '获取日志',
    '48': '开启ssh远程登录',
    '49': '关闭ssh远程登录',
    '50': '控制隔离终端',
    '51': '获取弱口令用户',
    '52': '进程控制',
    '53': '终端发现扫描',
  },
  'en-US': {
    '1': 'Message push',
    '2': 'Complete profile information',
    '3': 'Remove endpoint',
    '5': 'Shut down',
    '6': 'Restart',
    '7': 'One-click upgrade',
    '8': 'Full health check',
    '9': 'Quick scan',
    '10': 'Full disk scan',
    '11': 'Prompt to uninstall software',
    '12': 'Enable software uninstall',
    '13': 'Software distribution',
    '14': 'File distribution',
    '15': 'Optimize startup items',
    '16': 'Restore startup items',
    '19': 'Traffic monitoring',
    '20': 'Pop-up blocker engine control',
    '21': 'Pop-up blocker trust list control',
    '22': 'Leave team',
    '23': 'Domain block/allow list',
    '24': 'Startup item scan',
    '25': 'Console information sync',
    '26': 'Vulnerability remediation',
    '27': 'Vulnerability scan',
    '28': 'Port scan',
    '29': 'Port blocking',
    '30': 'Baseline scan',
    '31': 'Baseline remediation',
    '32': 'Team information changed',
    '33': 'Enable remote assistance',
    '34': 'Disable remote assistance',
    '35': 'Enable remote login',
    '36': 'Disable remote login',
    '37': 'Enable/disable user',
    '38': 'Membership benefit update',
    '39': 'Sensitive file scan',
    '40': 'Risk item handling',
    '41': 'Restore file',
    '42': 'Add trust zone',
    '43': 'Remove trust zone',
    '44': 'Update trust zone',
    '45': 'Update quarantine',
    '46': 'Change debug mode',
    '47': 'Collect logs',
    '48': 'Enable SSH remote login',
    '49': 'Disable SSH remote login',
    '50': 'Control quarantined endpoint',
    '51': 'Fetch weak-password users',
    '52': 'Process control',
    '53': 'Endpoint discovery scan',
  },
  'ja-JP': {
    '1': 'メッセージ配信',
    '2': '情報の補完',
    '3': '端末の削除',
    '5': 'シャットダウン',
    '6': '再起動',
    '7': 'ワンクリックアップグレード',
    '8': '総合診断',
    '9': 'クイックスキャン',
    '10': 'フルスキャン',
    '11': 'ソフトウェアアンインストールの通知',
    '12': 'ソフトウェアアンインストールの許可',
    '13': 'ソフトウェア配信',
    '14': 'ファイル配信',
    '15': 'スタートアップ項目の最適化',
    '16': 'スタートアップ項目の復元',
    '19': 'トラフィック監視',
    '20': 'ポップアップブロックエンジンの制御',
    '21': 'ポップアップブロック信頼リストの制御',
    '22': 'グループから退出',
    '23': 'ドメインブロック・ホワイトリスト',
    '24': 'スタートアップ項目スキャン',
    '25': '管理コンソール情報の同期',
    '26': '脆弱性修復',
    '27': '脆弱性スキャン',
    '28': 'ポートスキャン',
    '29': 'ポート遮断',
    '30': 'セキュリティ基準適合スキャン',
    '31': 'セキュリティ基準適合修復',
    '32': 'グループ情報の変更',
    '33': 'リモートアシスタンスを有効化',
    '34': 'リモートアシスタンスを無効化',
    '35': 'リモートログインを有効化',
    '36': 'リモートログインを無効化',
    '37': 'ユーザーの有効化/無効化',
    '38': 'メンバーシップ特典の更新',
    '39': '機密ファイルスキャン',
    '40': 'リスク項目の処理',
    '41': 'ファイルを復元',
    '42': '信頼領域に追加',
    '43': '信頼領域から削除',
    '44': '信頼領域の更新',
    '45': '隔離領域の更新',
    '46': 'デバッグモードの変更',
    '47': 'ログの取得',
    '48': 'SSHリモートログインを有効化',
    '49': 'SSHリモートログインを無効化',
    '50': '隔離端末の制御',
    '51': '脆弱なパスワードのユーザーを取得',
    '52': 'プロセス制御',
    '53': '端末検出スキャン',
  },
  'zh-TW': {
    '1': '訊息推播',
    '2': '補全資訊',
    '3': '刪除終端',
    '5': '關機',
    '6': '重新啟動',
    '7': '一鍵升級',
    '8': '全面體檢',
    '9': '閃電查殺',
    '10': '全盤查殺',
    '11': '提醒解除安裝軟體',
    '12': '開啟解除安裝軟體',
    '13': '軟體分發',
    '14': '檔案分發',
    '15': '最佳化啟動項',
    '16': '還原啟動項',
    '19': '流量監控',
    '20': '彈窗攔截引擎控制',
    '21': '彈窗攔截信任清單控制',
    '22': '退出團隊',
    '23': '網域攔截黑白名單',
    '24': '啟動項掃描',
    '25': '控制台資訊同步',
    '26': '弱點修復',
    '27': '弱點掃描',
    '28': '連接埠掃描',
    '29': '連接埠阻斷',
    '30': '基準掃描',
    '31': '基準修復',
    '32': '團隊資訊變更',
    '33': '開啟遠端協助',
    '34': '關閉遠端協助',
    '35': '開啟遠端登入',
    '36': '關閉遠端登入',
    '37': '啟用/停用使用者',
    '38': '會員權益更新',
    '39': '敏感檔案掃描',
    '40': '風險項處理',
    '41': '還原檔案',
    '42': '新增信任區',
    '43': '移除信任區',
    '44': '更新信任區',
    '45': '更新隔離區',
    '46': '修改偵錯模式',
    '47': '取得日誌',
    '48': '開啟 SSH 遠端登入',
    '49': '關閉 SSH 遠端登入',
    '50': '控制隔離終端',
    '51': '取得弱密碼使用者',
    '52': '程序控制',
    '53': '終端發現掃描',
  },
}
